// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import etask from 'zetask';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {Modal} from '../../../../hola/pub/lib/modal';
import {Btn_loader} from './btn_loader';
import Svg_success from '../../img/success.svg';
import Svg_warning from '../../img/icons/24/warning_triangle.svg';
import {api} from '../../../../toolip/pub/lib/api';

import styles from './dialogs.module.less';

interface i_confirm_dialog_props {
    on_confirm?: ()=>void;
    close: ()=>void;
    on_cancel?: ()=>void;
    is_open: boolean
    title: string
    sub_title?: string
    note?: string
    caption_cancel: string | JSX.Element
    caption_confirm: string | JSX.Element
    width?: number
    hide_buttons?: ('cancel' | 'confirm')[]
}
export const Confirmation_dialog = (props: i_confirm_dialog_props)=>{
    const {hide_buttons = []} = props;
    const {theme} = useContext(Settings_context);
    const [is_busy, set_is_busy] = useState(false);
    const width = props.width || 403;
    const confirm = ()=>etask(function*(){
        set_is_busy(true);
        yield props.on_confirm();
        set_is_busy(false);
    });
    const handle_cancel = ()=>{
        if (props.on_cancel)
            props.on_cancel();
        else
            props.close();
    };
    return <Modal lighter_close_btn={true} is_open={props.is_open}
      width={width} on_close={props.close}
      on_overlay_click={ev=>{
        props.close();
        ev.stopPropagation();
      }}
      paddingless={true}>
      <div className={styles.confirm_modal}>
        <p className={cn(theme.p20, theme.med, theme.color_n700, styles.mb)}>
          {props.title}
        </p>
        {props.sub_title &&
          <p className={cn(theme.p14, theme.med, theme.color_n600)}>
            {props.sub_title}
          </p>}
        {props.note &&
          <p className={cn(theme.p14, theme.reg, theme.color_n600,
            styles.note)}>
              {props.note}
          </p>}
        <div className={styles.btn_container}>
          {!hide_buttons.includes('cancel') &&
            <Button caption={props.caption_cancel} color='transparent'
              on_click={handle_cancel} cls={styles.btn} round={false}/>}
          {!hide_buttons.includes('confirm') &&
            <Button caption={is_busy ? <Btn_loader /> : props.caption_confirm}
              color='black' on_click={confirm} cls={styles.btn}
              round={false}/>}
        </div>
      </div>
    </Modal>;
};

interface i_simple_dialog_props {
    on_confirm: ()=>void;
    close: ()=>void;
    close_on_click_outside?: boolean;
    is_open: boolean
    icon?: JSX.Element
    title: string | JSX.Element
    sub_title?: string | JSX.Element
    bottom_text?: string | JSX.Element
    caption_confirm: string | JSX.Element
    width?: number
}
export const Simple_dialog = (props: i_simple_dialog_props)=>{
    const {theme} = useContext(Settings_context);
    const confirm = ()=>etask(function*(){
        yield props.on_confirm();
    });
    return <Modal lighter_close_btn={true} is_open={props.is_open}
      width={props.width ?? 403} on_close={props.close}
      on_overlay_click={ev=>{
        ev.stopPropagation();
        if (props.close_on_click_outside)
          props.close();
      }}
      paddingless={true}>
      <div className={styles.confirm_modal}>
        {props.icon && <div>{props.icon}</div>}
        <p className={cn(theme.p20, theme.bold, theme.color_n700, styles.mb)}>
          {props.title}
        </p>
        {props.sub_title &&
          <p className={cn(theme.p14, theme.med, theme.color_n600)}>
            {props.sub_title}
          </p>}
        <div className={styles.btn_container}>
          <Button caption={props.caption_confirm} color='primary'
            on_click={confirm}/>
        </div>
        {props.bottom_text}
      </div>
    </Modal>;
};

interface i_cancel_dialog_props {
    on_confirm: ()=>void;
    close: ()=>void;
    on_change_plan?: ()=>void;
    on_cancel_success?: ()=>void;
    product_id: string;
    gateway: string;
    is_open: boolean;
    width?: number;
    can_change_plan: boolean;
}

export const Cancel_dialog = (props: i_cancel_dialog_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const width = props.width || 403;
    const [is_busy, set_is_busy] = useState(false);
    const confirm = ()=>etask(function*(){
        set_is_busy(true);
        yield api.cancel_and_refund(props.product_id, false, props.gateway);
        set_is_busy(false);
        props.close();
        if (props.on_cancel_success)
            props.on_cancel_success();
    });
    const handle_change_plan = ()=>{
        history.push(`/pricing?refund_product_id=${props.product_id}`);
        props.close();
        if (props.on_change_plan)
            props.on_change_plan();
    };
    return <Modal
      lighter_close_btn={true}
      is_open={props.is_open}
      width={width} on_close={props.close}
      on_overlay_click={ev=>{
        props.close();
        ev.stopPropagation();
      }}
      paddingless={true}>
      <div className={styles.confirm_modal}>
        <div className={cn(styles.mb, styles.title_with_icon)}>
          <p className={cn(theme.p20, theme.med, theme.color_n700)}>
            Are you sure you want to cancel?
          </p>
          <Svg_warning/>
        </div>
        {props.can_change_plan &&
          <p className={cn(theme.p14, theme.reg, theme.color_n600,
            styles.subtitle_left)}>
              You might want to <a
                className={cn(theme.color_n700, styles.change_plan_link)}
                onClick={handle_change_plan}
              >change your plan</a> instead.
          </p>}
        <div className={styles.note_box}>
          <p className={cn(theme.p14, theme.reg, theme.color_n600,
            styles.note_header)}>
              If you cancel your plan:
          </p>
          <ul className={styles.bullet_list}>
            <li className={cn(theme.p14, theme.reg, theme.color_n600)}>
              This action is <span className={theme.color_n700}>
                permanent and cannot be undone.</span>
            </li>
            <li className={cn(theme.p14, theme.reg, theme.color_n600)}>
              You <span className={theme.color_n700}>
                will lose access </span>
                to all current proxies and any remaining bandwidth.
            </li>
          </ul>
        </div>
        <div className={styles.btn_container}>
            <Button
              caption={is_busy ? <Btn_loader /> : 'Cancel & refund'}
              color='transparent'
              round={false}
              cls={styles.btn}
              on_click={confirm} />
            <Button
              caption='Keep my proxies'
              color='black'
              round={false}
              cls={styles.btn}
              on_click={props.close} />
        </div>
      </div>
    </Modal>;
};

interface i_cancel_success_props {
  on_close: ()=>void;
  on_buy_plan?: ()=>void;
}

const Cancel_success = ({on_close, on_buy_plan}: i_cancel_success_props)=>{
    const {theme} = useContext(Settings_context);
    const handle_buy_plan = ()=>{
        if (on_buy_plan)
            on_buy_plan();
        else
            on_close();
    };
    return <div className={styles.cancel_success}>
      <Svg_success />
      <p className={cn(theme.p18, theme.med, theme.color_n700,
        styles.success_title)}>
          Plan canceled!
      </p>
      <p className={cn(theme.p14, theme.reg, theme.color_n600,
        styles.success_subtitle)}>
          Your plan has been cancelled and a refund has been issued to your
          account.
      </p>
      <div className={styles.success_btn_container}>
        <Button
          caption='Close'
          color='transparent'
          round={false}
          cls={styles.btn}
          on_click={on_close}
          size='sm'/>
        <Button
          caption='Buy a new plan'
          color='black'
          round={false}
          cls={styles.btn}
          on_click={handle_buy_plan}
          size='sm'/>
      </div>
    </div>;
};

interface i_cancel_success_modal_props {
    is_open: boolean;
    on_close: ()=>void;
    on_buy_plan?: ()=>void;
}

export const Cancel_success_modal = ({is_open, on_close, on_buy_plan}:
    i_cancel_success_modal_props)=>{
    return <Modal is_open={is_open}
      on_close={on_close}
      paddingless
      low_dim={true}
      no_logo
      width={476}
      on_overlay_click={on_close}>
        <Cancel_success on_close={on_close} on_buy_plan={on_buy_plan} />
    </Modal>;
};
